require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./page-2.json") })
        }
      }, "path---page-2");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---page-2!./.cache/json/page-2.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---page-2!./.cache/json/page-2.json
// module chunks = 231608221292675